import React from 'react';

import {ConfirmSelection} from 'presentation/pages';

export const MakeConfirmSelection: React.FC = () => <ConfirmSelection />;
